import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { DmField, DmTextarea } from '../../dm/DmFormPrimitives';
import { validateForceReason } from './forceOverride';

interface ForceOverridePanelProps {
    open: boolean;
    onOpen: () => void;
    onCancel: () => void;
    reason: string;
    onReasonChange: (reason: string) => void;
}

// Escape hatch surfaced next to the blocked banner - see useForceOverrideState
// for the platform-level `billing.update` gate that decides whether this mounts.
function ForceOverridePanel({
    open,
    onOpen,
    onCancel,
    reason,
    onReasonChange
}: ForceOverridePanelProps) {
    if (!open) {
        return (
            <button
                type="button"
                onClick={onOpen}
                className="self-start inline-flex items-center gap-2 px-3 py-2 h-8 border border-red-800 text-red-800 rounded-lg font-semibold text-sm hover:bg-red-50 transition-colors"
            >
                <ExclamationTriangleIcon className="w-4 h-4" />
                Override and send anyway
            </button>
        );
    }

    const error = validateForceReason(reason);

    return (
        <div className="flex flex-col gap-3 p-4 rounded-xl border border-red-300 bg-red-50">
            <p className="text-sm text-red-900">
                <span className="font-semibold">Billing override:</span> this will send a purchase
                order even though one was already sent/charged for this case. Requires
                platform-level billing access. The action is fully audited.
            </p>
            <DmField label="Reason for override" required error={error}>
                <DmTextarea value={reason} onChange={onReasonChange} rows={3} error={!!error} />
            </DmField>
            <button
                type="button"
                onClick={onCancel}
                className="self-start text-xs font-semibold text-red-800 underline hover:text-red-900"
            >
                Cancel override
            </button>
        </div>
    );
}

export { ForceOverridePanel };
